import { INotification } from '@/model/interface/INotification'

export class PostNotification implements INotification {
  post = 0

  constructor(post: number) {
    this.post = post
  }
}
